<app-current-voltage *ngIf="widget === 'current-voltage'"
                     [resizeEvent]="resizeEvent"
                     [Currentmeter]="Thing.controlCabinet.propertySets.get('CURRENTMETER')">
</app-current-voltage>

<app-sum-of-power *ngIf="widget === 'sum-of-power'"
                  [resizeEvent]="resizeEvent"
                  [Currentmeter]="Thing.controlCabinet.propertySets.get('CURRENTMETER')">
</app-sum-of-power>

<app-image *ngIf="widget === 'image'"
           [resizeEvent]="resizeEvent"
           [heading]="'Darstellung PRBG' | translate"
           [src]="Thing.model3D"
           [equipmentNumber]="Thing.equipmentNumber"
           [alt]="'Darstellung PRBG' | translate"
           [ain]="Thing.ainUrl"
           [width]="'auto'">
</app-image>


<app-energy-consumption *ngIf="widget === 'energy-consumption'"
                        [resizeEvent]="resizeEvent"
                        [Energy]="Thing.controlCabinet.propertySets.get('ENERGY')">
</app-energy-consumption>

<app-distance *ngIf="widget === 'distance'"
              [resizeEvent]="resizeEvent"
              [HorizontalDistance]="Thing.propertySets.get('HORIZONTAL_DISTANCE')"
              [VerticalDistance]="Thing.propertySets.get('VERTICAL_DISTANCE')"
              [TelescopeDistance]="Thing.propertySets.get('TELESCOPE_DISTANCE')">
</app-distance>

<app-statistic *ngIf="widget === 'statistic'"
               [resizeEvent]="resizeEvent"
               [Statistic]="Thing.propertySets.get('STATISTICS')">
</app-statistic>

<app-status *ngIf="widget === 'status'"
            [resizeEvent]="resizeEvent"
            [Status]="Thing.propertySets.get('STATUS')">
</app-status>


<app-cm-sensors *ngIf="widget === 'cm-lam'"
                [resizeEvent]="resizeEvent"
                [Type]="'LAM'"
                [Environment]="Thing.propertySets.get('DS_ENV')"
                [Rotation]="Thing.propertySets.get('DS_ROT')"
                [AngularVelocity]="Thing.propertySets.get('DS_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('DS_ACL')">
</app-cm-sensors>


<app-cm-sensors-two *ngIf="widget === 'cm-lam-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'LAM'"
                    [Environment]="Thing.propertySets.get('DS_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('DS_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('DS_ACL')">
</app-cm-sensors-two>

<app-cm-sensors *ngIf="widget === 'cm-mdw'"
                [resizeEvent]="resizeEvent"
                [Type]="'MDW'"
                [Environment]="Thing.propertySets.get('MDW_ENV')"
                [Rotation]="Thing.propertySets.get('MDW_ROT')"
                [AngularVelocity]="Thing.propertySets.get('MDW_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('MDW_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cm-mdw-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'MDW'"
                    [Environment]="Thing.propertySets.get('MDW_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('MDW_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('MDW_ACL')">
</app-cm-sensors-two>

<app-cm-sensors *ngIf="widget === 'cm-mtop'"
                [resizeEvent]="resizeEvent"
                [Type]="'MTOP'"
                [Environment]="Thing.propertySets.get('MTOP_ENV')"
                [Rotation]="Thing.propertySets.get('MTOP_ROT')"
                [AngularVelocity]="Thing.propertySets.get('MTOP_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('MTOP_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cm-mtop-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'MTOP'"
                    [Environment]="Thing.propertySets.get('MTOP_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('MTOP_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('MTOP_ACL')">
</app-cm-sensors-two>

<app-cm-sensors *ngIf="widget === 'cth-cm-ccm'"
                [resizeEvent]="resizeEvent"
                [Type]="'CCM'"
                [Environment]="Thing.propertySets.get('CCM_ENV')"
                [Rotation]="Thing.propertySets.get('CCM_ROT')"
                [AngularVelocity]="Thing.propertySets.get('CCM_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('CCM_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cth-cm-ccm-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'CCM'"
                    [Environment]="Thing.propertySets.get('CCM_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('CCM_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('CCM_ACL')">
</app-cm-sensors-two>

<app-cm-sensors *ngIf="widget === 'cth-cm-lfdown'"
                [resizeEvent]="resizeEvent"
                [Type]="'LFDOWN'"
                [Environment]="Thing.propertySets.get('LFDW_ENV')"
                [Rotation]="Thing.propertySets.get('LFDW_ROT')"
                [AngularVelocity]="Thing.propertySets.get('LFDW_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('LFDW_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cth-cm-lfdown-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'LFDOWN'"
                    [Environment]="Thing.propertySets.get('LFDW_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('LFDW_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('LFDW_ACL')">
</app-cm-sensors-two>

<app-cm-sensors *ngIf="widget === 'cth-cm-lftop'"
                [resizeEvent]="resizeEvent"
                [Type]="'LFTOP'"
                [Environment]="Thing.propertySets.get('LFTOP_ENV')"
                [Rotation]="Thing.propertySets.get('LFTOP_ROT')"
                [AngularVelocity]="Thing.propertySets.get('LFTOP_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('LFTOP_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cth-cm-lftop-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'LFTOP'"
                    [Environment]="Thing.propertySets.get('LFTOP_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('LFTOP_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('LFTOP_ACL')">
</app-cm-sensors-two>

<app-cm-sensors *ngIf="widget === 'cth-cm-mbl'"
                [resizeEvent]="resizeEvent"
                [Type]="'MBL'"
                [Environment]="Thing.propertySets.get('MBL_ENV')"
                [Rotation]="Thing.propertySets.get('MBL_ROT')"
                [AngularVelocity]="Thing.propertySets.get('MBL_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('MBL_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cth-cm-mbl-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'MBL'"
                    [Environment]="Thing.propertySets.get('MBL_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('MBL_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('MBL_ACL')">
</app-cm-sensors-two>

<app-cm-sensors *ngIf="widget === 'cth-cm-smd2'"
                [resizeEvent]="resizeEvent"
                [Type]="'SMD2'"
                [Environment]="Thing.propertySets.get('SMD2_ENV')"
                [Rotation]="Thing.propertySets.get('SMD2_ROT')"
                [AngularVelocity]="Thing.propertySets.get('SMD2_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('SMD2_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cth-cm-smd2-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'SMD2'"
                    [Environment]="Thing.propertySets.get('SMD2_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('SMD2_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('SMD2_ACL')">
</app-cm-sensors-two>

<app-cm-sensors *ngIf="widget === 'cth-cm-smd3'"
                [resizeEvent]="resizeEvent"
                [Type]="'SMD3'"
                [Environment]="Thing.propertySets.get('SMD3_ENV')"
                [Rotation]="Thing.propertySets.get('SMD3_ROT')"
                [AngularVelocity]="Thing.propertySets.get('SMD3_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('SMD3_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cth-cm-smd3-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="'SMD3'"
                    [Environment]="Thing.propertySets.get('SMD3_ENV')"
                    [AngularVelocity]="Thing.propertySets.get('SMD3_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('SMD3_ACL')">
</app-cm-sensors-two>